module.exports = __webpack_public_path__ + "static/media/LinkedIN.46887c85.svg";